//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDownloadFile } from '@/api/MES/orderManagement.js';
import { picFilter } from '@/assets/utils';
export default {
  name: 'QcReview',
  props: {
    checkOrderDetailVoList: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      dialogImageUrl: "",
      dataList: []
    };
  },
  methods: {
    previewFile: function previewFile(url) {
      var fileUrl = picFilter(url, {
        size: 'large'
      });
      this.dialogImageUrl = fileUrl;
      this.dialogVisible = true;
    },
    uploadFile: function uploadFile(fileId) {
      getDownloadFile(fileId);
    }
  }
};